import { createAction } from '/@/store/utils';

export const reset = createAction('WEED_FINDER:RESET');
export const setFilter = createAction('WEED_FINDER:SET_FILTER');
export const setSearch = createAction('WEED_FINDER:SET_SEARCH');
export const setViewType = createAction('WEED_FINDER:SET_VIEW_TYPE');
